/**
 * Petitions — placeholder page (Sam, 2026-05-18).
 *
 * Phone-based petition / campaign signature collection: a caller dials
 * in, hears the campaign description, and presses a key to register
 * their support. Captures caller ID plus optional spoken comment and
 * flexible signature fields the campaign needs.
 *
 * Shipped as a stub today — the sidebar entry + feature flag are live
 * so the surface is reachable, but the IVR node, capture flow, list /
 * detail UI, and reporting are queued for the next pass.
 */
import { ClipboardList, Megaphone } from 'lucide-react';
import { PageHeader } from '@/components/PageHeader';
import { Card, CardContent } from '@/components/ui/card';

export function PetitionsPage() {
  return (
    <>
      <PageHeader
        eyebrow="Engagement"
        title="Petitions"
        description="Phone-based petition / campaign signature collection. Callers dial in, hear the campaign description, and press a key to register their support."
      />

      <Card>
        <CardContent className="py-10 text-center">
          <ClipboardList className="mx-auto h-8 w-8 text-slate-300 mb-3" />
          <p className="text-sm font-medium text-slate-500">
            Petitions are coming soon.
          </p>
          <p className="text-xs text-muted-foreground mt-2 max-w-md mx-auto">
            This will let you run signature drives entirely over the phone — set
            up a campaign, route an IVR node to it, and watch signatures roll in
            with caller ID, an optional spoken comment, and any custom signature
            fields you define.
          </p>
        </CardContent>
      </Card>

      <Card className="mt-4">
        <CardContent className="p-4">
          <div className="flex items-start gap-3">
            <Megaphone className="h-5 w-5 text-slate-400 shrink-0 mt-0.5" />
            <div className="text-xs text-muted-foreground space-y-1">
              <p className="font-medium text-slate-700">What you&rsquo;ll be able to do</p>
              <ul className="list-disc ms-5 space-y-0.5">
                <li>Define a campaign with description audio + signature fields</li>
                <li>Drop a <code className="rounded bg-slate-100 px-1 text-[10px]">petition</code> node into any IVR tree</li>
                <li>Auto-capture caller ID and optional spoken comment</li>
                <li>Export signatures + listen to comments from the dashboard</li>
                <li>Send confirmation SMS to signers (when SMS is enabled)</li>
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
